import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registrul-monte-in-harem',
  templateUrl: './registrul-monte-in-harem.component.html',
  styleUrls: ['./registrul-monte-in-harem.component.scss']
})
export class RegistrulMonteInHaremComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
